module.exports = __webpack_public_path__ + "img/lks_speaker_najib.e6c4af53.jpg";